module.exports = __webpack_public_path__ + "jira.png?f049122097415bd918adf109f8ad5e17";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/partners/jira.png
// module id = 184
// module chunks = 0